// extracted by mini-css-extract-plugin
module.exports = {"footer":"_93444fe79c--footer--sWTRb","footer-withNbConsultant":"_93444fe79c--footer-withNbConsultant--Ecng6","footer--submit":"_93444fe79c--footer--submit--GT7fg"};